module.exports = __webpack_public_path__ + "ticket-account.svg?db9a1d75b702de64675709e812e62814";